import React from 'react';
import Card from '../../components/Card';
import CardGroup from '../../components/CardGroup';

export default function Balance() {
  return (
    <>
      <h2>Overview</h2>
      <CardGroup>
        <Card
          title="Annual Leave"
          value="44"
          label="hours"
        />
        <Card
          title="Sick Leave"
          value="12"
          label="hours"
        />
      </CardGroup>
    </>
  );
}
